var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import React from 'react';
import { observer } from 'mobx-react';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import Table from '../table/Table';
import JsonTree from '../json-tree/JsonTree';
import Pane from '../pane/Pane';
import LineChart from '../chart/LineChart';
import Popout from '../popout/Popout';
import FAIcon from '../icons/FAIcon';
import './context-pane.scss';
let ContextPane = class ContextPane extends React.Component {
    deleteChart(id) {
        return () => this.props.store.charts.deleteChart(id);
    }
    render() {
        const { data, globalTypes, globalFunctions, layout, charts, contextIndex, changeContextIndex, settings, } = this.props.store;
        return (React.createElement(Pane, { className: "context-pane", panel: "context", title: "Context", store: layout },
            React.createElement(Tabs, { defaultIndex: contextIndex, onSelect: changeContextIndex },
                React.createElement(TabList, null,
                    React.createElement(Tab, null, "Context Table"),
                    React.createElement(Tab, null, "Context JSON"),
                    React.createElement(Tab, null, "Global Types"),
                    React.createElement(Tab, null, "Global Functions"),
                    React.createElement(Tab, null, "Charts")),
                React.createElement(TabPanel, null, data ? React.createElement(Table, { data: data }) : React.createElement("div", { className: "empty" })),
                React.createElement(TabPanel, null, data ? React.createElement(JsonTree, { data: data }) : React.createElement("div", { className: "empty" })),
                React.createElement(TabPanel, null,
                    React.createElement(JsonTree, { data: globalTypes })),
                React.createElement(TabPanel, null,
                    React.createElement(JsonTree, { data: globalFunctions })),
                React.createElement(TabPanel, null, charts.lines.size === 0 ? (React.createElement("div", { className: "empty" })) : (React.createElement("div", { className: "charts-container" }, [...charts.lines].map(([id, chartStore], i) => (React.createElement("div", { key: i, className: "chart-container" },
                    React.createElement("div", { className: "chart-header" },
                        React.createElement("span", { className: "chart-title" }, chartStore.id),
                        React.createElement("div", { className: "chart-actions" },
                            React.createElement(FAIcon, { className: "fas fa-external-link-square-alt", onClick: chartStore.popout }),
                            React.createElement(FAIcon, { className: "fa fa-trash", onClick: this.deleteChart(id) }))),
                    React.createElement("div", { className: "chart-content" },
                        React.createElement(Popout, { title: `LineChart "${chartStore.id}" - GreyCat Studio`, isPopped: chartStore.isPopped },
                            React.createElement(LineChart, { store: chartStore, settings: settings }))))))))))));
    }
};
ContextPane = __decorate([
    observer
], ContextPane);
export default ContextPane;
